/* eslint-disable eqeqeq */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { getInventory, getOrganizationData, updateExtapies } from "../../../services/api";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import CustomDatePicker from "../../commons/CustomDatePicker";
const UpdateExtapiDialog = ({ initialData, onClose, onSaveResponse, open }) => {
  const [t] = useTranslation();
  const [input, setInput] = useState({
    organization: null,
    inventory: null,
    url: "",
    account: "",
    password: "",
    sync_at: "",
  });

  // method
  const handleSave = () => {
    return updateExtapies(initialData?.id, {
      organization_id: input.organization?.id,
      inventory_id: input.inventory?.id,
      url: input.url,
      account: input.account,
      password: input.password,
      sync_at: moment(input.sync_at).format("YYYY-MM-DD"),
    });
  };
  // effect
  useEffect(() => {
    if (!initialData) return;
    else setInput(initialData);
  }, [initialData]);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle align="center">{t("Cập nhật thông tin kết nối kho đầu nguồn")}</DialogTitle>
      <DialogContent>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10 }}>
          <FilterBy
            style={{ display: "inline-flex", minWidth: 240 }}
            getDataFunc={() => getOrganizationData({ status: 1 })}
            value={input.organization || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, organization: newValue }))}
            label={t("Tổ chức")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, organization: option.find((item) => item.id == initialData.organization_id) }))}
            triggerSetDefaultFunc={Boolean(initialData)}
            setDefaultDependencies={[initialData]}
          />
          <FilterBy
            style={{ display: "inline-flex", minWidth: 240 }}
            getDataFunc={() => getInventory({ status: 1 })}
            value={input.inventory || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, inventory: newValue }))}
            label={t("Kho hàng")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, inventory: option.find((item) => item.id == initialData.inventory_id) }))}
            triggerSetDefaultFunc={Boolean(initialData)}
            setDefaultDependencies={[initialData]}
          />
          <TextField fullWidth label={t("URL")} value={input.url} onChange={(e) => setInput((prev) => ({ ...prev, url: e.target.value }))} />
          <TextField fullWidth label={t("Tài khoản")} value={input.account} onChange={(e) => setInput((prev) => ({ ...prev, account: e.target.value }))} />
          <TextField
            type="password"
            autoComplete="new-password"
            fullWidth
            label={t("Mật khẩu mới")}
            value={input.password}
            onChange={(e) => setInput((prev) => ({ ...prev, password: e.target.value }))}
          />
          <CustomDatePicker format="DD/MM/YYYY" label={t("Thời gian đồng bộ")} value={input.sync_at} onChange={(value) => setInput((prev) => ({ ...prev, sync_at: value }))} sx={{ width: "100%" }} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICall variant="contained" api={handleSave} response={onSaveResponse}>
          {t("Lưu")}
        </ButtonWithAPICall>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateExtapiDialog;
